<div class="mb-4">
    <div class="col-sm-1">
        <button class="btn btn-success " (click)="clickedNew()">{{ 'simple-travel-list.label.new' | translate}}</button>
    </div>
    <h2>{{'simple-travel-list.avaible.offer.windows' | translate}}: {{window}}</h2>
</div>
<table class="table table-striped" *ngIf="travels">
    <thead>
        <tr>
            <td>{{ 'simple-travel-list.label.edit-delete' | translate}}</td>
            <td style="cursor:pointer;" [class.active]="order === 'at'" (click)="setOrder('at')">{{ 'simple-travel-list.label.window' | translate}}
                <span *ngIf="order === 'at'"><span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td>
            <td style="cursor:pointer;" [class.active]="order === 'desc'" (click)="setOrder('desc')">{{ 'simple-travel-list.label.description' | translate}}
                <span *ngIf="order === 'desc'"> <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td>
            <td style="cursor:pointer;" [class.active]="order === 'supplier'" (click)="setOrder('supplier')">{{ 'simple-travel-list.label.supplier' | translate}}
                <span *ngIf="order === 'supplier'"> <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td>
            <td style="cursor:pointer;" [class.active]="order === 'accommodation.name'" (click)="setOrder('accommodation.name')">{{ 'simple-travel-list.label.hotel' | translate}}
                <span *ngIf="order === 'accommodation.name'"><span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td>
            <td style="cursor:pointer;" [class.active]="order === 'firstStart'" (click)="setOrder('firstStart')">{{ 'simple-travel-list.label.earliestDate' | translate}}
                <span *ngIf="order === 'firstStart'"><span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td>
            <td [class.active]="order === 'fromPrice'" (click)="setOrder('fromPrice')" style="text-align:right; padding-right: 20px;cursor:pointer;">{{ 'simple-travel-list.label.fromPricePerPerson' | translate}}
                <span *ngIf="order === 'fromPrice'"><span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td>
            <!-- <td style="cursor:pointer;" [class.active]="order === 'homepageType'">{{ 'simple-travel-list.label.homepageType' | translate}}
                <span *ngIf="order === 'active'"><span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td> -->
            <td style="cursor:pointer;" [class.active]="order === 'active'" (click)="setOrder('active')">{{ 'simple-travel-list.label.active' | translate}}
                <span *ngIf="order === 'active'"><span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span></span>
            </td>

        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let travel of travels | orderBy: order:reverse:'case-insensitive'; let i = index" [ngClass]="{activeColor: travel.at != null}">
            <td><button class="btn btn-primary" [routerLink]="['/products/simpleTravel', travel.id]">{{ 'simple-travel-list.label.edit' | translate}}</button>
                <button (click)="deleteSimpleTravel(travel, i)" class="btn btn-danger">{{ 'simple-travel-list.label.delete' | translate}}</button></td>
            <td>
                <!-- {{travel.at}} -->
                <select class="select-offer" [(ngModel)]="travel.at" (change)="changeOfferWindowNumber(travel.at, travel, i)">
                <!-- <option  *ngFor="let at of disabledOfferNumberEntries" value="{{at.at}}" >{{at.at}}</option> -->
                <option value=1>1</option>
                <option value=2>2</option>
                <option value=3 [hidden]="window < 4">3</option>
                <option value=4  [hidden]="window < 4">4</option>
              </select>

            </td>
            <td>{{travel.desc}}</td>
            <td>{{travel.supplier}}</td>
            <td>{{travel.accommodation.name}}</td>
            <td>{{travel.dateTermin}}</td>
            <td style="text-align:right; padding-right: 20px;">{{travel.convertedPrice}}</td>
            <!-- <td>{{travel.homepageType}}</td> -->
            <td style="cursor: pointer;" (click)="setTravelStatus(travel)">
                <button class="btn" [hidden]="!travel.active" [ngClass]="{btnActivated: travel.active, btnDeactivated: !travel.active}">{{ 'simple-travel-list.label.active-yes' | translate}}</button>
                <button class="btn" [hidden]="travel.active" [ngClass]="{btnActivated: travel.active, btnDeactivated: !travel.active}">{{ 'simple-travel-list.label.active-no' | translate}}</button>
            </td>
        </tr>
    </tbody>
</table>
<div class="spinner" *ngIf="spinnerLoading">
    <div class="centered">
        <img src="../../../assets/loading_spinner.gif">
        <p><b>Please waith</b></p>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/product/simple-travel-list/simple-travel-list.component.html